import { Component, OnInit } from '@angular/core';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-demo',
  templateUrl: './demo.component.html',
  styleUrls: ['./demo.component.css']
})
export class DemoComponent implements OnInit {

  focus: boolean;
  focus1: boolean;

  public alerts: Array<IAlert> = [];
  private backup: Array<IAlert>;

  closeResult: string;

  constructor(private modalService: NgbModal) { }

  ngOnInit(): void {
    this.alerts.push({
          id: 1,
          type: 'success',
          strong: 'Well done!',
          message: 'You successfully read this important alert message.',
          icon: 'ui-2_like'
      }, {
          id: 2,
          strong: 'Heads up!',
          type: 'info',
          message: 'This is an info alert',
          icon: 'travel_info'
      }, {
          id: 3,
          type: 'warning',
          strong: 'Warning!',
          message: 'This is a warning alert',
          icon: 'ui-1_bell-53'
      }, {
          id: 4,
          type: 'danger',
          strong: 'Oh snap!',
          message: 'This is a danger alert',
          icon: 'objects_support-17'
      });
      this.backup = this.alerts.map((alert: IAlert) => Object.assign({}, alert));
  }

  public closeAlert(alert: IAlert) {
      const index: number = this.alerts.indexOf(alert);
      this.alerts.splice(index, 1);
  }

  open(content, type, modalDimension) {
    if (modalDimension === 'sm' && type === 'modal_mini') {
        this.modalService.open(content, { windowClass: 'modal-mini modal-primary', size: 'sm' }).result.then((result) => {
            this.closeResult = `Closed with: ${result}`;
        }, (reason) => {
            this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        });
    } else if (modalDimension === undefined && type === 'Login') {
      this.modalService.open(content, { windowClass: 'modal-login modal-primary' }).result.then((result) => {
          this.closeResult = `Closed with: ${result}`;
      }, (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      });
    } else {
        this.modalService.open(content).result.then((result) => {
            this.closeResult = `Closed with: ${result}`;
        }, (reason) => {
            this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        });
    }

}

private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
        return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
        return 'by clicking on a backdrop';
    } else {
        return  `with: ${reason}`;
    }
}
}

export interface IAlert {
  id: number;
  type: string;
  strong?: string;
  message: string;
  icon?: string;
}
